<template>
  <div class="margin">
    <ol class="c-breadcrumb" >
      <li class="c-breadcrumb__item" v-for="(bread, index) in breadcrumb" :key="bread">
        <router-link v-if="bread.hasLink && index < breadcrumb.length - 1" :to="bread.path" class="c-breadcrumb__link">
          {{
            bread.label
          }}
        </router-link>
        <span v-else-if="!bread.hasLink && index < breadcrumb.length - 1" class="c-breadcrumb__link">
          {{
            bread.label
          }}
        </span>
        <span v-else>
          {{
            bread.label
          }}
        </span>
      </li>
    </ol>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import breadcrumbStorage from '@/storage/breadcrumb'
  import Panel from '@/components/template/Panel'

  export default {
    data: () => ({
      route: '',
      fullRoute: '',
      breadcrumb: [],
      level: 1
    }),
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.fullRoute = ''
        this.breadcrumb.splice(0, this.breadcrumb.length)
        this.route = this.$route.fullPath

        const breadcrumbCloned = cloneDeep(breadcrumbStorage)

        const currentLevel = 0
        this.recursive(breadcrumbCloned, currentLevel)
      },
      recursive (items, currentLevel) {
        for (let i in items) {
          const item = items[i]

          if (currentLevel < this.breadcrumb.length) {
            continue
          }

          for (let i in Object.keys(this.$route.params)) {
            const prop = Object.keys(this.$route.params)[i]

            item.path = item.path.replace(`:${prop}`, this.$route.params[prop])
            item.label = item.label.replace(`:${prop}`, this.$route.params[prop])
          }

          if (this.route.indexOf(item.path) === 0) {
            this.breadcrumb.push({
              label: item.label,
              path: this.fullRoute.replace('//', '/') + item.path,
              hasLink: item.hasLink
            })

            this.fullRoute += item.path + '/'

            this.route = this.route.replace(item.path, '')

            if (this.route.indexOf('/') === 0) {
              this.route = this.route.replace('/', '')
            }

            if (item.children.length) {
              this.recursive(item.children, ++currentLevel)
            }
          }
        }
      }
    },
    components: {
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-bottom: 10px

</style>



// WEBPACK FOOTER //
// Breadcrumb.vue?41b6f059